/**
 * UI elements
 */
class NatAug_UI {
    constructor() {
        this.initSmoothScroll();
        this.initNewestInfoBlock();
    }

    initSmoothScroll () {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top - 200
                    }, 1000);
                }
            }
        });
    }

    initNewestInfoBlock () {
        let currentBlock = $('.nataug-newest-info');
        let status = Cookies.get('nataug-newest-info');

        if (!currentBlock.length) {
            return;
        }

        let currentBlockID = currentBlock.attr('data-id');
        currentBlockID = currentBlockID.replace(/[^a-z0-9\-\_]/gmi, '');
        
        if (status !== currentBlockID) {
            setTimeout(() => {
                currentBlock.removeClass('is-hidden');

                currentBlock.find('.nataug-newest-info-close').on('click', e => {
                    e.preventDefault();
                    currentBlock.addClass('is-hidden');
                    Cookies.set('nataug-newest-info', currentBlockID, { expires: 30 });

                    setTimeout(() => {
                        currentBlock.remove();
                    }, 500);
                });

                currentBlock.find('a').each((i, link) => {
                    let linkItem = $(link);
                    linkItem.on('click', e => {
                        e.preventDefault();
                        Cookies.set('nataug-newest-info', currentBlockID, { expires: 30 });
                        currentBlock.addClass('is-hidden');
                        setTimeout(() => {
                            window.location.href = linkItem.attr('href');
                        }, 100);
                    });
                });
            }, 3000);
        } else {
            currentBlock.remove();
        }
    }
}
